import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";
import { createSceneSwitcher } from "$/game/prefabs/ui/SceneSwitcher.ts";
import * as twaSDK from "@telegram-apps/sdk";
import { RoundedTextButton } from "$/game/prefabs/ui/RoundedTextButton.ts";
import { ImageButton } from "$/game/prefabs/ui/ImageButton.ts";

export class PetCreateScene extends BasicScene {
  private petSprite!: Phaser.GameObjects.Sprite;
  private petNameText!: Phaser.GameObjects.Text;
  private currentPetIndex: number = 0;
  private petTypes!: string[];
  private readonly baseScale: number = 1;

  constructor() {
    super("PetCreateScene");
  }

  create(): void {
    // this.soundManager.playMusic(this.keys.assets.sounds.music.home);

    // Инициализируем petTypes здесь, так как this.keys доступен только после init()
    this.petTypes = Object.keys(this.keys.assets.sprites.pets);

    const { width, height } = this.scale;
    const centerX = width / 2;
    const centerY = height / 2;

    this.petNameText = this.add.text(
      centerX,
      centerY - 200,
      this.getCurrentPetName(),
      {
        fontSize: "40px",
        color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
        fontFamily: "Phantom-Muff",
        fontStyle: "bold",
      },
    ).setOrigin(0.5);

    const petFrame = this.keys.assets.sprites
      .pets[
        this
          .petTypes[
            this.currentPetIndex
          ] as keyof typeof this.keys.assets.sprites.pets
      ].normal;
    this.petSprite = this.add.sprite(centerX, centerY, this.atlas, petFrame)
      .setOrigin(0.5)
      .setScale(this.baseScale);

    const prevButton = new ImageButton(
      this,
      centerX - 200,
      centerY,
      this.atlas,
      this.keys.assets.sprites.ui.buttonLeft,
      () => {
        this.changePet(-1);
        twaSDK.hapticFeedback.selectionChanged();
        this.soundManager.playSound(this.keys.assets.sounds.penClick, {
          volume: 0.25,
        });
      },
    );

    const nextButton = new ImageButton(
      this,
      centerX + 200,
      centerY,
      this.atlas,
      this.keys.assets.sprites.ui.buttonRight,
      () => {
        this.changePet(1);
        twaSDK.hapticFeedback.selectionChanged();
        this.soundManager.playSound(this.keys.assets.sounds.penClick, {
          volume: 0.25,
        });
      },
    );

    const createButton = new RoundedTextButton(
      this,
      centerX,
      centerY + 250,
      this.keys.strings.choosePetButton,
      323,
      72,
      25,
      this.global.TUNER_TWA_CONFIG.palette.primary,
      this.global.TUNER_TWA_CONFIG.palette.primary + 0x100000,
      {
        fontSize: "40px",
        fontStyle: "normal",
        fontFamily: "Phantom-Muff",
        color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
      },
    );

    createButton.on("pointerdown", () => {
      this.soundManager.playSound(this.keys.assets.sounds.penClick, {
        volume: 0.25,
      });
      this.createPet();
    });

    createSceneSwitcher(this);
  }

  private getCurrentPetName(): string {
    const currentPetType = this.petTypes[this.currentPetIndex];
    return this.keys.strings.petNames
      ?.[currentPetType as keyof typeof this.keys.strings.petNames] ||
      currentPetType;
  }

  private changePet(direction: number): void {
    this.currentPetIndex =
      (this.currentPetIndex + direction + this.petTypes.length) %
      this.petTypes.length;

    const petFrame = this.keys.assets.sprites
      .pets[
        this
          .petTypes[
            this.currentPetIndex
          ] as keyof typeof this.keys.assets.sprites.pets
      ].normal;
    this.petSprite.setTexture(this.atlas, petFrame);
    this.petNameText.setText(this.getCurrentPetName());

    this.tweens.killTweensOf(this.petSprite);
    this.petSprite.setScale(this.baseScale);

    this.tweens.add({
      targets: this.petSprite,
      scaleX: 0.8,
      scaleY: 0.8,
      duration: 100,
      yoyo: true,
      ease: "Power2",
      onComplete: () => this.petSprite.setScale(this.baseScale),
    });
  }

  private async createPet(): Promise<void> {
    const selectedPet = this.petTypes[this.currentPetIndex];
    this.overlay.show("LoadingOverlay", false);
    const petResponse = await this.api.pet.create(selectedPet);
    this.overlay.close("LoadingOverlay");

    if (petResponse.data == null) {
      this.global.TWA.showAlert("Не удалось создать питомца", () => {});
    } else {
      this.registry.set("pet", petResponse.data);
      this.transition.toScene(
        "EggBrakeScene",
        this.keys.strings.sceneTransitions.brakeEgg,
      );
    }
  }
}
